import i18n from "@/i18n";
import VueI18n from "vue-i18n";

export const playerReportFields = [
    {
        key: "isActive",
        label: "",
        sortable: true
    },
    {
        key: "playerName",
        label: i18n.t("common.name"),
        sortable: true
    },
    {
        key: "playerFolderPath",
        label: i18n.t("reports.playerPlacement"),
        sortable: true
    },
    {
        key: "playerId",
        label: i18n.t("reports.playerActivationNumber"),
        sortable: true
    },
    {
        key: "playerType",
        label: i18n.t("player.playerType"),
        sortable: true
    },
    {
        key: "activationDate",
        label: i18n.t("player.activationDate"),
        sortable: true
    },
    {
        key: "lastActiveDate",
        label: i18n.t("reports.playerLastActive"),
        sortable: true
    }
];
